import React, { Component } from "react";
import PropTypes from "prop-types";
import ProductCard from "./product-card";
import pricePropType from "../price/price";
import gql from "graphql-tag";

export const PRODUCT_CARD_FRAGMENT = gql`
    fragment ProductCard on Product {
        productId
        shortDescription
        productUrl
        dateAdded
        saved
        designer {
            slug
            name
        }
        buyOptions(count: 1) {
            linkId
            freeShipping
            dateAdded
            hasPromotions
            leadUrl
            images(count: 1) {
                url(width: 200, height: 250)
            }
            retailer {
                slug
                name
                retailerType
            }
            sizes {
                currentPrice {
                    value
                    currency
                }
                price {
                    value
                    currency
                }
                onSale
                discount
                stockStatus
            }
        }
    }
`;

class GraphQLProductCard extends Component {
    render() {
        const {
            shortDescription,
            buyOptions,
            productUrl,
            imageSize,
            designer,
            saved,
            productId,
            isLoggedIn
        } = this.props;

        const bestBuyOption = buyOptions[0];

        const { sizes, freeShipping, hasPromotions, retailer } = bestBuyOption;

        const isAffiliate = retailer.retailerType === "AFFILIATE";

        const bestSize = sizes[0];

        const inStock = bestSize.stockStatus === "IN_STOCK";
        const price = bestSize.price.value;
        const currentPrice = bestSize.currentPrice.value;
        const currency = bestSize.currentPrice.currency;

        const { onSale } = bestSize;
        let { discount } = bestSize;
        discount = Math.floor(parseFloat(discount) * 100);

        let imageUrl = bestBuyOption.images[0].url;

        let leadEnabled = true;
        if (!isAffiliate) {
            leadEnabled = false;
        }
        if (isLoggedIn) {
            leadEnabled = false;
        }

        return (
            <ProductCard
                designerName={designer.name}
                freeShipping={freeShipping}
                fullPrice={price}
                imageSize={imageSize}
                imageUrl={imageUrl}
                inStock={inStock}
                isAffiliate={isAffiliate}
                leadEnabled={leadEnabled}
                leadUrl={bestBuyOption.leadUrl}
                onSale={onSale}
                retailerName={retailer.name}
                salePercentage={discount}
                salePrice={currentPrice}
                productUrl={productUrl}
                shortDescription={shortDescription}
                hasPromotions={hasPromotions}
                currency={currency}
                isSaved={saved}
                isLoggedIn={isLoggedIn}
                productId={productId}
            />
        );
    }
}

export default GraphQLProductCard;

const dateAddedPropType = PropTypes.string;

const designerPropType = PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
});

const retailerPropType = PropTypes.shape({
    retailerType: PropTypes.oneOf(["ICON", "AFFILIATE"])
});

const imagePropType = PropTypes.shape({
    url: PropTypes.string.isRequired
});
const imagesPropType = PropTypes.arrayOf(imagePropType);

const stockStatusPropType = PropTypes.oneOf(["IN_STOCK", "OUT_OF_STOCK", "PREORDER"]);

const sizePropType = PropTypes.shape({
    stockStatus: stockStatusPropType.isRequired,
    price: pricePropType.isRequired,
    currentPrice: pricePropType.isRequired,
    onSale: PropTypes.bool.isRequired,
    discount: PropTypes.string.isRequired
});

const sizesPropType = PropTypes.arrayOf(sizePropType);

const buyOptionsPropType = PropTypes.arrayOf(
    PropTypes.shape({
        linkId: PropTypes.string.isRequired,
        freeShipping: PropTypes.bool.isRequired,
        hasPromotions: PropTypes.bool.isRequired,
        dateAdded: dateAddedPropType.isRequired,
        retailer: retailerPropType.isRequired,
        images: imagesPropType.isRequired,
        leadUrl: PropTypes.string.isRequired,
        sizes: sizesPropType.isRequired
    })
);

GraphQLProductCard.propTypes = {
    shortDescription: PropTypes.string.isRequired,
    productUrl: PropTypes.string.isRequired,
    dateAdded: dateAddedPropType.isRequired,
    saved: PropTypes.bool.isRequired,
    designer: designerPropType.isRequired,
    buyOptions: buyOptionsPropType.isRequired,
    imageSize: PropTypes.oneOf(["LARGE", "SMALL"]).isRequired,
    productId: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    isLoggedIn: PropTypes.bool.isRequired
};

GraphQLProductCard.defaultProps = {
    imageSize: "LARGE"
};
